import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=3cc70635"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc70635')) {
      api.createRecord('3cc70635', component.options)
    } else {
      api.reload('3cc70635', component.options)
    }
    module.hot.accept("./Inputs.vue?vue&type=template&id=3cc70635", function () {
      api.rerender('3cc70635', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "libs/components/FormBuilder/ComponentsByTypes/InputType/Inputs.vue"
export default component.exports